/* CuddleBuds Rewards — Shopify storefront controller.
   Display only. The free gift is issued by Razorpay Magic Checkout's
   freebie coupon, not by this script. */
(function () {
  "use strict";

  const rewards = [
    { threshold: 499, reward: "Free Delivery" },
    { threshold: 1299, reward: "Free Delivery + ₹100 off" },
    { threshold: 1799, reward: "Free delivery + ₹100 off + Mix Meat Bone Broth", detail: "(Free Gift)" }
  ];

  /* Line item property used by the old auto-add logic. Kept only so that
     carts created before the Razorpay switchover get cleaned up. Safe to
     remove this, and removeLegacyGiftLine below, after a few weeks. */
  const GIFT_PROPERTY = "_cb_reward_gift";

  const REFRESH_DEBOUNCE_MS = 300;

  const panel = document.querySelector(".cb-rewards");
  const dialog = document.querySelector(".cb-rewards__dialog");
  const icon = document.querySelector("#cb-header-reward");
  let lastActiveElement;
  let refreshTimer;
  let refreshInFlight = false;

  const money = value => new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR", maximumFractionDigits: 0
  }).format(value);

  const rewardIcon = isEarned => isEarned
    ? '<svg class="cb-reward-icon cb-reward-icon--check" viewBox="0 0 24 24" aria-hidden="true"><path d="m8.3 12.2 2.3 2.3 5.1-5.1M12 2.8l2 1.6 2.6-.1.7 2.5 2.1 1.5-.8 2.5.8 2.5-2.1 1.5-.7 2.5-2.6-.1-2 1.6-2-1.6-2.6.1-.7-2.5-2.1-1.5.8-2.5-.8-2.5 2.1-1.5.7-2.5 2.6.1z"/></svg>'
    : '<svg class="cb-reward-icon cb-reward-icon--star" viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3.1 2.55 5.16 5.7.83-4.13 4.02.98 5.68L12 16.12 6.9 18.8l.98-5.68-4.13-4.02 5.7-.83z"/></svg>';

  async function getCart() {
    const root = window.Shopify?.routes?.root || "/";
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Could not load cart");
    const cart = await response.json();
    return {
      total: cart.items_subtotal_price / 100,
      itemCount: cart.item_count,
      items: cart.items,
      items_subtotal_price: cart.items_subtotal_price
    };
  }

  function renderMilestones(container, cart, earned, next) {
    if (!container) return;
    container.innerHTML = rewards.map(reward => {
      const isEarned = cart.total >= reward.threshold;
      const state = isEarned ? "cb-milestone--earned" : reward === next ? "cb-milestone--next" : "";
      return `<article class="cb-milestone ${state}"><span class="cb-milestone__badge">${rewardIcon(isEarned)}</span><p class="cb-milestone__amount">${money(reward.threshold)}</p><p class="cb-milestone__reward">${reward.reward}${reward.detail ? `<br>${reward.detail}` : ""}</p></article>`;
    }).join("");
  }

  function renderCartMilestones(container, cart, earned, next) {
    if (!container) return;
    container.innerHTML = rewards.map(reward => {
      const isEarned = cart.total >= reward.threshold;
      const state = isEarned ? "cb-cart-rewards__milestone--earned" : reward === next ? "cb-cart-rewards__milestone--next" : "";
      return `<article class="cb-cart-rewards__milestone ${state}"><span class="cb-cart-rewards__badge">${rewardIcon(isEarned)}</span><p class="cb-cart-rewards__amount">${money(reward.threshold)}</p><p class="cb-cart-rewards__reward">${reward.reward}${reward.detail ? `<br>${reward.detail}` : ""}</p></article>`;
    }).join("");
  }

  function buildMessage(cart, earned, next) {
    if (!next) return "Free delivery + ₹100 off bill + Bone Broth unlocked!";
    const lead = earned.length > 1
      ? `${earned[earned.length - 1].reward} ${earned[earned.length - 1].detail || ""} unlocked.`
      : "Start earning rewards.";
    return `${lead} Add items worth ${money(next.threshold - cart.total)} more to get ${next.reward}!`;
  }

  function buildSavings(earned) {
    return earned.length > 1
      ? `🎉 You've unlocked ${earned.length - 1} reward${earned.length > 2 ? "s" : ""}!`
      : "🎉 Your first reward is waiting!";
  }

  function render(cart) {
    const earned = rewards.filter(reward => cart.total >= reward.threshold);
    const next = rewards.find((reward, index) => index > 0 && cart.total < reward.threshold);
    const progress = Math.min(100, (cart.total / rewards[rewards.length - 1].threshold) * 100);

    /* The icon is rendered on every page, but visible only when the cart has an item. */
    if (icon) {
      icon.hidden = cart.itemCount === 0;
      icon.setAttribute("aria-hidden", String(cart.itemCount === 0));
    }

    const popupFill = document.querySelector("[data-cb-progress-fill]");
    if (popupFill) {
      popupFill.style.width = `${progress}%`;
      popupFill.style.setProperty("--cb-popup-progress", `${progress}%`);
      popupFill.classList.toggle("cb-progress--complete", progress >= 100);
    }

    renderMilestones(document.querySelector("[data-cb-milestones]"), cart, earned, next);

    const popupMessage = document.querySelector("[data-cb-message]");
    if (popupMessage) popupMessage.textContent = buildMessage(cart, earned, next);

    const popupSavings = document.querySelector("[data-cb-savings]");
    if (popupSavings) popupSavings.textContent = buildSavings(earned);

    renderCartMeter(cart, earned, next, progress);
  }

  function renderCartMeter(cart, earned, next, progress) {
    document.querySelectorAll("[data-cb-cart-meter]").forEach(meter => {
      const meterFill = meter.querySelector("[data-cb-cart-meter-fill]");
      if (meterFill) {
        meterFill.style.setProperty("--cb-progress", `${progress}%`);
        meterFill.style.width = `${progress}%`;
        meterFill.classList.toggle("cb-progress--complete", progress >= 100);
      }

      renderCartMilestones(meter.querySelector("[data-cb-cart-meter-milestones]"), cart, earned, next);

      const meterMessage = meter.querySelector("[data-cb-cart-meter-message]");
      if (meterMessage) meterMessage.textContent = buildMessage(cart, earned, next);

      const meterSaving = meter.querySelector("[data-cb-cart-meter-saving]");
      if (meterSaving) meterSaving.textContent = buildSavings(earned);
    });
  }

  /* Legacy cleanup only. Removes a gift line left over from the old
     auto-add logic so the customer does not end up with two gifts once
     Razorpay applies its freebie coupon. Never adds anything. */
  async function removeLegacyGiftLine(cart) {
    const root = window.Shopify?.routes?.root || "/";
    const giftLine = cart.items.find(
      item => item.properties && item.properties[GIFT_PROPERTY] === "true"
    );
    if (!giftLine) return false;

    try {
      await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: giftLine.key, quantity: 0 })
      });
      return true;
    } catch (error) {
      console.warn("CB Rewards could not remove the legacy gift line", error);
      return false;
    }
  }

  async function runRefresh() {
    if (refreshInFlight) return;
    refreshInFlight = true;

    try {
      let cart = await getCart();
      const removed = await removeLegacyGiftLine(cart);
      if (removed) cart = await getCart();
      render(cart);
    } catch (error) {
      console.warn("CB Rewards could not read the Shopify cart", error);
    } finally {
      refreshInFlight = false;
    }
  }

  /* Debounced so that a burst of cart operations results in one read.
     Razorpay Magic also polls /cart.js heavily; without this the two
     together can trip Shopify's cart rate limit. */
  function refresh() {
    if (document.hidden) return;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(runRefresh, REFRESH_DEBOUNCE_MS);
  }

  function open() {
    lastActiveElement = document.activeElement;
    panel?.setAttribute("aria-hidden", "false");
    window.setTimeout(() => dialog?.focus(), 0);
  }

  function close() {
    panel?.setAttribute("aria-hidden", "true");
    lastActiveElement?.focus();
  }

  icon?.addEventListener("click", open);
  document.querySelectorAll("[data-cb-close-rewards]").forEach(button =>
    button.addEventListener("click", close)
  );
  document.addEventListener("keydown", event => {
    if (event.key === "Escape") close();
  });
  document.addEventListener("cart:updated", refresh);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) refresh();
  });
  window.addEventListener("pageshow", refresh);

  /* Catch standard Shopify Ajax cart operations, including add, update, change, and clear. */
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async function (...args) {
    const response = await nativeFetch(...args);
    const requestUrl = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:[?#]|$)/.test(requestUrl)) {
      refresh();
    }
    return response;
  };

  window.CBRewards = { refresh, open, close };
  runRefresh();
}());